//npm packages
import dayjs from 'dayjs';
import React from 'react';
import { Input } from 'reactstrap';

//Helper files
import consts from '../../consts';

export default ({ input, ...rest }) => {
  const {
    meta,
    placeholder,
    type,
    disabled,
    maxLength,
    defaultValue,
    tabIndex,
    className,
    min,
    max,
    accept,
    rows,
    autoComplete,
    style,
    divStyle = {}
  } = rest || {};
  const { touched, error, warning } = meta || {};
  let { value, ...restInput } = input || {};
  value =
    value && value.toString().startsWith(' ')
      ? value.trim()
      : type === 'date'
      ? dayjs(value).format(consts.MomentFormat.Date)
      : value;
  return (
    <div className="loginFields" style={divStyle}>
      <Input
        {...restInput}
        tabIndex={tabIndex}
        type={type}
        {...(type === 'file' ? {} : { value })}
        defaultValue={defaultValue}
        placeholder={placeholder}
        className={className}
        disabled={!!disabled}
        maxLength={maxLength}
        autoComplete={
          autoComplete || type === 'password' ? 'new-password' : 'off'
        }
        autoCorrect="off"
        spellCheck="off"
        min={min}
        max={max}
        rows={rows}
        accept={accept}
        style={style}
      />
      {touched &&
        ((error && <span className="required-color-red">{error}</span>) ||
          (warning && <span className="warning-color">{warning}</span>))}
    </div>
  );
};
